import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatMenu, MatMenuContent, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { TranslateModule } from '@ngx-translate/core';
import { ELoadStatus } from '../../../state/state.interface';
import { InlineMenuPositionService } from '../../../utilities/inline-menu-position.service';
import { ItemPriorityComponent } from '../item-priority/item-priority.component';
import { EItemPriority, itemPriorityOrder } from '../item-priority/item-priority.interface';
import { InlineItemPriorityStore } from './inline-item-priority.store';

@Component({
  imports: [MatMenu, MatMenuContent, MatMenuItem, MatMenuTrigger, ItemPriorityComponent, TranslateModule],
  providers: [InlineItemPriorityStore],
  selector: 'app-inline-item-priority',
  styleUrl: './inline-item-priority.component.scss',
  templateUrl: './inline-item-priority.component.html',
})
export class InlineItemPriorityComponent implements OnInit {
  @ViewChild('menuTrigger') menuTrigger!: MatMenuTrigger;

  @Input({ required: true }) public itemId!: number | null;
  @Input() public priority: EItemPriority | null = null;
  @Output() triggerRefresh: EventEmitter<void> = new EventEmitter<void>();

  public readonly priorities: EItemPriority[] = itemPriorityOrder;
  public menuYPosition: 'above' | 'below' = 'below';
  public menuXPosition: 'before' | 'after' = 'after';

  constructor(
    public readonly store: InlineItemPriorityStore,
    private readonly inlineMenuPositionService: InlineMenuPositionService,
  ) {}

  public ngOnInit(): void {
    this.store.editItemLoading$.subscribe((status: ELoadStatus) => {
      if (status === ELoadStatus.success) {
        this.triggerRefresh.emit();
      }
    });
  }

  public selectMenuItem(priority: EItemPriority): void {
    if (!this.itemId || priority === this.priority) {
      return;
    }

    this.store.editItemPriority({ id: this.itemId, priority });
  }

  public onTriggerClick(triggerElem: HTMLElement): void {
    const { yPosition, xPosition } = this.inlineMenuPositionService.calculateMenuPosition(triggerElem);
    this.menuYPosition = yPosition;
    this.menuXPosition = xPosition;

    setTimeout(() => {
      this.menuTrigger.openMenu();
    });
  }
}
